var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPortfolioIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 5.73251V4.78601C21 3.46079 21 2.79816 20.7093 2.292C20.4537 1.84675 20.0457 1.48476 19.544 1.25791C18.9736 1 18.2268 1 16.7333 1H5.26667C3.77319 1 3.02645 1 2.45603 1.25791C1.95425 1.48476 1.54631 1.84675 1.29065 2.292C1 2.79816 1 3.46079 1 4.78601V5.73251M1 5.73251V16.144C1 17.4693 1 18.1319 1.29065 18.6381C1.54631 19.0833 1.95425 19.4453 2.45603 19.6721C3.02645 19.93 3.77319 19.93 5.26667 19.93H20.7333C22.2268 19.93 22.9736 19.93 23.544 19.6721C24.0457 19.4453 24.4537 19.0833 24.7093 18.6381C25 18.1319 25 17.4693 25 16.144V9.51852C25 8.1933 25 7.53067 24.7093 7.02451C24.4537 6.57926 24.0457 6.21727 23.544 5.99042C22.9736 5.73251 22.2268 5.73251 20.7333 5.73251H1ZM25 10.465H22.3333C20.8605 10.465 19.6667 11.5244 19.6667 12.8313C19.6667 14.1382 20.8605 15.1975 22.3333 15.1975H25",
    stroke: "#12D8FA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioIcon2);
export default __webpack_public_path__ + "static/media/PortfolioIcon2.08c366bf5db6d34cf3034257f2c27627.svg";
export { ForwardRef as ReactComponent };